import * as React from 'react';
import Hero from './Hero';
import Services from './Services';
import Events from './Events';
import Partners from './Partners';
/* import Testimonials from './Testimonials';
 */
const HomePage: React.FC = () => {
    return (
        <React.Fragment>
            <Hero />
            <Services />
            <Events />
{/*             <Testimonials /> */}
            <Partners />
        </React.Fragment>

    );
}

export default HomePage; 